import { render, staticRenderFns } from "./BaseFileUpload.vue?vue&type=template&id=8405aee4&scoped=true&"
import script from "./BaseFileUpload.vue?vue&type=script&lang=js&"
export * from "./BaseFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileUpload.vue?vue&type=style&index=0&id=8405aee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8405aee4",
  null
  
)

export default component.exports